import { render, staticRenderFns } from "./Redes.vue?vue&type=template&id=1622ed9a&scoped=true"
import script from "./Redes.vue?vue&type=script&lang=js"
export * from "./Redes.vue?vue&type=script&lang=js"
import style0 from "./Redes.vue?vue&type=style&index=0&id=1622ed9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1622ed9a",
  null
  
)

export default component.exports